import { useEffect } from 'react';
import { useAuth } from '../auth/useAuth';
import { useSAPDataStore } from '../store/SAPDataStore';

/**
 * Component that initializes the current user in the SAP store
 * This must be inside the AuthGuard to have access to the auth context
 */
export const UserInitializer = () => {
  const { user } = useAuth();
  const { setCurrentUser } = useSAPDataStore();

  // Set current user in SAP store when user changes
  useEffect(() => {
    if (user?.username) {
      console.log(`👤 UserInitializer: Setting current user to "${user.username}"`);
      setCurrentUser(user.username);
    } else {
      console.log('👤 UserInitializer: Clearing current user (no auth user)');
      setCurrentUser(null);
    }
  }, [user?.username, setCurrentUser]);

  return null; // This component doesn't render anything
};
